// extracted by mini-css-extract-plugin
export default {"addButton":"addtocart_addButton__TQAVj"};